import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=0d065cbe"
import script from "./ImportModal.vue?vue&type=script&lang=js"
export * from "./ImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports